import React,{useEffect, useState}from 'react'
import Main from '../../cpn/Main'
import { Table,Space, message, } from 'antd';
import FeedbackAdd from './FeedbackAdd';
import { useBnsFanKuiJianChaDelMutation, useBnsFanKuiJianChaListQuery } from '../../store/ReactWebSiteApi';
import FeedbackEdit from './FeedbackEdit';
import ModalDel from '../../cpn/ModalDel';
import FeedbackCheck from './FeedbackCheck';
import FeedbackState from './FeedbackState';
function FeedbackList() {       
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsFanKuiJianChaListQuery();    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bfkjc_id:key,bfkjc_name,bfkjc_ctime,bfkjc_cname,bfkjc_content,bfkjc_dept_id,bfkjc_dept_name,bfkjc_jihuariqi,bfkjc_meijie_name,bfkjc_fuzhuren_name,bfkjc_state} = item;
                    return item = {key,bfkjc_name,bfkjc_ctime,bfkjc_cname,bfkjc_content,bfkjc_dept_id,bfkjc_dept_name,bfkjc_jihuariqi,bfkjc_meijie_name,bfkjc_fuzhuren_name,bfkjc_state}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bfkjc_ctime;
                    let bTimeString = b.bfkjc_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'bfkjc_jihuariqi',
            title: '日期',            
            dataIndex:'bfkjc_jihuariqi'
        },    
     
        {
            key: 'bfkjc_meijie_name',
            title: '媒介',            
            dataIndex: 'bfkjc_meijie_name',
            
        },
        {
            key: 'bfkjc_fuzhuren_name',
            title: '负责人',            
            dataIndex: 'bfkjc_fuzhuren_name',            
        },
         {
            key: 'bfkjc_name',
            title: '检查内容',
            dataIndex:'bfkjc_name',
            render:(_,record) => {
                return  <FeedbackCheck
                            bfkjc_id={record.key}
                            bfkjc_name={record.bfkjc_name}
                        />
            }
        },  
        {
            key: 'bfkjc_state',
            title: '状态',
            dataIndex:'bfkjc_state',
            render:(text) => {
                if(text==='1'){
                    return<>已实现</>
                }else{
                    return<>待实现</>
                }
            }   
        },          
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',            
        },
        {
            key: 'bfkjc_dept_name',
            title: '部门',            
            dataIndex: 'bfkjc_dept_name',
            
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bfkjc_ctime + record.bfkjc_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <FeedbackEdit
                            bfkjc_id={record.key}
                        />            
                        <ModalDel onOk={() => {
                            del({bfkjc_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} />
                        <FeedbackState 
                            bfkjc_id={record.key}
                            bfkjc_state={record.bfkjc_state}
                        />   
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsFanKuiJianChaDelMutation()
    return (
        <Main t1='推广'  t2='反馈检查'>
            <Space size='large'>
                <FeedbackAdd />             
            </Space> 
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"20px"}}
            />
        </Main>
    )
}

export default FeedbackList